export const environment = {
    production: true,
    graphqlEndpoint: 'https://enti-backend.ict.unipd.it/graphql',
    airbrakeProjectKey: '081fea25a74a63b4c7435793456a3a9b',
    errorsUrl: 'https://errors.moku.io'
  ,
};